enum UnleashPermissions {
  NewScheduleButtons = 'iclinic-frontend.schedule.iclinic-assist-schedule',
  GlicFlag = 'carecare.glic.enabled',
  CheckoutV2Routes = 'iclinic-frontend.checkout.v2_routes',
  TissXmlWithoutBom = 'iclinic-frontend.tiss.xml_without_bom',
}

export default UnleashPermissions;
